<div class="overlay delete-batch-alert">

    

    <div class="overlay-body delete-msg" *ngIf="deleteMsg">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>Are you sure you want to delete this alert?</p>
                 </div>
            </div>
        </div>
        <div class="button-controls">
            <f-button text="No" title="No" type="button" variant="action"  (click)="exitModal()"></f-button>
            <f-button text="Yes" title="Yes" type="button" variant="progressive"  (click)="progressDeleted()"></f-button>
        </div>
    </div>  
    
    <div class="overlay-body delete-progress hide1" *ngIf="batchAlertService.progressBarForDeleteBatchAlert">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>Deleting Batch Attention Items</p>

                    <mat-progress-bar mode="indeterminate" value="40"></mat-progress-bar>
            
                    <p>Please wait, your batch attention item is being deleted</p>
                 </div>
            </div>
        </div>       
    </div>
    
    
   
    
    

    
   
   
    
    



</div>